import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { getProviderColor, getProviderInitials } from '../../helpers';
import styles from './HuddleNotes.module.scss';

const formatNoteTime = (at) =>
  new Date(at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

const HuddleNotes = ({ notes = [], onPostNote }) => {
  const [draft, setDraft] = useState('');

  const postDraft = () => {
    const text = draft.trim();
    if (!text) return;
    onPostNote(text);
    setDraft('');
  };

  return (
    <>
      <div className={styles.headerRow}>
        <span className={styles.header}>Huddle notes</span>
        {notes.length > 0 && (
          <span className={styles.headerMeta}>
            {notes.length} {notes.length === 1 ? 'note' : 'notes'}
          </span>
        )}
      </div>

      {notes.length > 0 && (
        <div className={styles.threadRow}>
          {notes.map((note) => (
            <div key={note.id} className={styles.note}>
              <span
                className={styles.avatar}
                style={{ background: getProviderColor(note.author) }}
                aria-hidden="true"
              >
                {getProviderInitials(note.author)}
              </span>
              <div className={styles.noteBody}>
                <div className={styles.noteText}>{note.text}</div>
                <div className={styles.noteMeta}>
                  {note.author} · {formatNoteTime(note.createdAt)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className={styles.composerRow}>
        <textarea
          className={styles.composer}
          placeholder="Add a note for this visit…"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
              event.preventDefault();
              postDraft();
            }
          }}
        />
        <div className={styles.composerButtons}>
          <button
            type="button"
            className={styles.postButton}
            disabled={!draft.trim()}
            onClick={postDraft}
          >
            Post note
          </button>
        </div>
      </div>
    </>
  );
};

HuddleNotes.propTypes = {
  notes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      author: PropTypes.string,
      createdAt: PropTypes.string,
    }),
  ),
  onPostNote: PropTypes.func.isRequired,
};

export default HuddleNotes;
